<template>
  <div class="one-tag">
    <div class="title">
      <p>进出库记录单</p>
    </div>
    <div class="table-wrapper">
      <table>
        <tr>
          <th>时间</th>
          <th>出库/入库</th>
          <th>物品名称</th>
          <th>属性</th>
          <th>数量</th>
          <th>来源/去向</th>
          <th>原因</th>
          <th>备注</th>
          <th class="sign">签名</th>
        </tr>
        <tr v-for="(item,index) in item.flowList" :key="index">
          <td>{{item.dotime}}</td>
          <td>{{item.direction}}</td>
          <td>{{item.name}}</td>
          <td>{{revealProperty(item.property)}}</td>
          <td>{{item.amount}}</td>
          <td>{{item.place}}</td>
          <td>{{item.reason}}</td>
          <td>{{item.remark}}</td>
          <td></td>
        </tr>
      </table>
    </div>
    <div class="tail">
      <p><span style="margin-right:5pt;">第{{item.currentPage}}页</span>
      <span>共{{item.totalPage}}页</span>
      </p>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "wareNote",
  props: {
    item: {
      type: Object,
      default: ()=>{
        return {};
        }
    },
  },
  components: {
  },
  data() {
    return {
      nowTime: dayjs().format("YYYY-MM-DD"),
    };
  },
  methods: {
    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
  },
  mixins: [],
  mounted() {

  },
  created() {},
  computed: {},
  watch: {},
};
</script>
<style scoped>
.one-tag {
  width: 840.36pt;
  min-height: 592.0pt;
  outline: #666 solid 1px;
  text-align: left;
  position: relative;
  margin: 1px;
  overflow: hidden;
  cursor: pointer;
}
.title p{
  font-size: 25pt;
  font-weight: 700;
}
.static-title {
  font-family: "KaiTi";
  font-size: 26pt;
}

.imp {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 700;
}

.tag-part {
  padding: 1pt 50pt;
}

.tag-content-inner {
  border: 1px solid #333;
}

.part-title {
  padding: 5pt 30pt;
  font-size: 10pt;
  border-bottom: 1px solid #999;
}

.part-title .title-s{
  font-size: 8pt;
  color:#999;
}

.part-content {
  padding: 5pt 50pt;
  font-size: 12pt;
}

.tag-title {
  padding-top: 50px;
}

.tag-title-inner {
  position: relative;
}

.tag-title .title-name {
  font-size: 24pt;
  text-align: center;
  font-weight: 600;
  margin-bottom: 18pt;
}

.tag-title .sub-title {
  font-size: 14pt;
  text-align: center;
}

.tag-title .g-i,
.tag-title .p-i {
  position: absolute;
  top: 0pt;
  font-size: 12pt;
}

.tag-title .p-i {
  right: 0pt;
}

.tag-title .qc_no{
  position: absolute;
  left:0;
  font-size: 8pt;
}

.tag-title .g-i {
  right: 0pt;
  font-weight: 600;
  border: 1pt solid #999;
  padding: 3pt 15pt;
  border-radius: 3pt;
  color: #000;
}

table.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12pt;
}

table.info-table td {
  border: 1px solid #333;
  padding: 3pt 15pt;
}

table.info-table > tr > td:nth-child(2n + 1) {
  text-align: right;
}

table.info-table > tr > td:nth-child(2n) {
  text-align: center;
}

.part-content-end {
  display: flex;
}

.part-content-end .left {
  width: 70%;
  padding: 20pt 50pt;
  line-height: 2;
  font-size: 10pt;
  color: #666;
}

.part-content-end .right {
  padding: 15pt;
  width: 30%;
}

.qr-img {
  width: 100%;
}

.sample-inner {
  padding: 10pt 0;
}

.sample-inner:first-child {
  border-bottom: 1px dashed #999;
}

.sample-inner table,
.sample-list-name {
  width: 90%;
  text-align: center;
  margin: 0 auto;
}

.title-s {
  font-size: 10pt;
  color: #666;
}

.sample-inner-title-wrapper {
  padding: 5pt 0;
}

.sample-inner table td {
  padding: 3pt 10pt;
  border: 1px dotted #aaa;
}
.sample-inner table {
  font-size: 11pt;
}

.title{
  text-align: center;
  padding: 20pt 0 10pt;
  font-size: 14pt;
}

.table-wrapper table{
  width:100%;
  border-collapse: collapse;
  border:1px solid #999;
  
}

.table-wrapper table td,.table-wrapper table th{
  border:1px solid #999;
  padding: 3pt 5pt;
  text-align: center;
  overflow: hidden;
  white-space:nowrap;
}
.table-wrapper{
  margin:5pt 30pt;
}

.tail{
  position: absolute;
  right:30pt;
  bottom:30pt;
}
.sign{
  width:60pt;
}
</style>